import { render, staticRenderFns } from "./CardOutagesNearYou.vue?vue&type=template&id=ffdee026&scoped=true&"
import script from "./CardOutagesNearYou.vue?vue&type=script&lang=js&"
export * from "./CardOutagesNearYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdee026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffdee026')) {
      api.createRecord('ffdee026', component.options)
    } else {
      api.reload('ffdee026', component.options)
    }
    module.hot.accept("./CardOutagesNearYou.vue?vue&type=template&id=ffdee026&scoped=true&", function () {
      api.rerender('ffdee026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountdashboard/CardOutagesNearYou.vue"
export default component.exports